import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "./constants";
import { BookingLink } from "./BookingLink";

const BrandMark = () => (
  <span className="brand__mark">
    <svg width="22" height="22" viewBox="0 0 40 40" fill="none" stroke="#0B1B33" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 32 L6 22 Q20 4 34 22 L34 32" /><path d="M6 32 L34 32" /><path d="M13 32 L13 24" /><path d="M20 32 L20 20" /><path d="M27 32 L27 24" /></svg>
  </span>
);

export const SiteHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    const onResize = () => window.innerWidth > 980 && setOpen(false);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <header className={`site-header surface-dark${scrolled ? " is-scrolled" : ""}${open ? " is-open" : ""}`} data-testid="site-header">
      <div className="site-header__inner">
        <a className="brand" href="#top" aria-label="AI Arena, home" data-testid="brand-home-link" onClick={() => setOpen(false)}>
          <BrandMark />
          <span className="brand__text">
            <span className="brand__name">AI ARENA</span>
            <span className="brand__tag">YOUR AI OFFICER</span>
          </span>
        </a>
        <nav className="site-nav" aria-label="Main">
          <ul className="site-nav__links">
            {NAV_LINKS.map((l) => (
              <li key={l.id}><a className="site-nav__link" href={`#${l.id}`} data-testid={`nav-link-${l.id}`}>{l.label}</a></li>
            ))}
          </ul>
          <BookingLink className="btn btn--sm btn--amber" testId="header-cta-free-check">Free AI check</BookingLink>
          <button type="button" className="menu-toggle" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} aria-controls="mobile-menu" onClick={() => setOpen((o) => !o)} data-testid="mobile-menu-toggle">
            {open ? <X size={22} aria-hidden="true" /> : <Menu size={22} aria-hidden="true" />}
          </button>
        </nav>
      </div>
      <nav id="mobile-menu" className="mobile-menu" aria-label="Mobile" aria-hidden={!open} inert={!open} data-testid="mobile-menu">
        <ul className="mobile-menu__links">
          {NAV_LINKS.map((l) => (
            <li key={l.id}>
              <a className="mobile-menu__link" href={`#${l.id}`} tabIndex={open ? 0 : -1} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${l.id}`}>{l.label}</a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};
